import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { setStorageAccessBannerEnabledAction } from '../../actions/app';
import { getIsStorageAccessBannerEnabled } from '../../selectors/app';
import { CheckoutState } from '../../state';

const mapStateToProps = (state: CheckoutState) => ({
    isStorageAccessBannerEnabled: getIsStorageAccessBannerEnabled(state),
});

export const mapDispatchToProps = (dispatch: Dispatch<CheckoutState>) => ({
    handleOnClose: () => {
        dispatch(setStorageAccessBannerEnabledAction(false));
    },
});

export const connectStorageAccess = connect(
    mapStateToProps,
    mapDispatchToProps,
);

export type ConnectedProps = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;
